<template>
  <div id="tesMap" class="d-flex justify-content-center">
    
    <MglMap
        v-if="coordinates[0]"
      :zoom="15"
      :center="coordinates"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
    >
      <MglGeocoderControl :accessToken="accessToken" @result="pickPlace" />
      <MglNavigationControl position="top-right" />
      <MglGeolocateControl position="top-right" />
      <MglMarker
        @dragend="getMarkerPosition"
        :draggable="true"
        :coordinates="coordinates"
        color="blue"
      />
    </MglMap>
  </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import MglGeocoderControl from "vue-mapbox-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
// import 'mapbox-gl/dist/mapbox-gl.css'
import {
  MglMap,
  MglNavigationControl,
  MglGeolocateControl,
  MglMarker,
} from "vue-mapbox";

export default {
  name: "TesUpdate",
  components: {
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglMarker,
    MglGeocoderControl,
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoibWlrZWhhbWlsdG9uMDAiLCJhIjoiNDVjS2puUSJ9.aLvWM5BnllUGJ0e6nwMSEg", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/streets-v11", // your map style
      getCoordinates: this.passcoordinates ? this.passcoordinates : [0, 0],
    };
  },
  mounted() {
    console.log("masuk");
    console.log(this.coordinates);
    console.log(this.passcoordinates);
  },
  computed: {
    coordinates() {
        console.log(this.passcoordinates, 'masuk ke computed');
      return this.passcoordinates
    },
  },
  props: ["passcoordinates"],
  methods: {
    getMarkerPosition(event) {
      // console.log(event.marker._lngLat);
      const longitude = event.marker._lngLat.lng;
      const latitude = event.marker._lngLat.lat;
      console.log(longitude, latitude, "di tes map");
      this.$emit("updateLocation", { longitude, latitude });
    },
    pickPlace(event) {
      console.log(event.result.geometry.coordinates);
      const longitude = event.result.geometry.coordinates[0];
      const latitude = event.result.geometry.coordinates[1];
      console.log(longitude, latitude, "ini pick place");
      //   this.coordinates = event.result.geometry.coordinates
      this.$emit("updateLocation", { longitude, latitude });
    },
  },

  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox;
  },
};
</script>

<style scoped>
#tesMap .mgl-map-wrapper {
  height: 50vh;
  width: 100vh;
}
</style>
